/* @flow */
import Entity from 'lib/Entity';

export default class RelatedUserSummary extends Entity {
  getUuid(): string {
    return this.get('uuid');
  }

  getFirstName(): string {
    return this.get('first_name');
  }

  getLastName(): string {
    return this.get('last_name');
  }

  getDisplayName(): string {
    return this.get('display_name');
  }

  getInitials(): ?string {
    return this.get('initials');
  }

  getColor(): ?string {
    return this.get('color');
  }
}



// WEBPACK FOOTER //
// ./src/entities/RelatedUserSummary.js